import SDError from './SDError';

export default class GQLResponseError extends SDError {
  errors = [];

  constructor(message, gql_errors = []) {
    super(message);

    this.errors = gql_errors;
  }
}



// WEBPACK FOOTER //
// ./src/model/GQLResponseError.js